import DodoneContext from 'app/dodones/Context'
import DodoneInnerIgnoreButton from 'app/dodones/shared/InnerIgnoreButton'

export default ({ text = 'Ignore' }) => {
  const dodoneContext = useContext(DodoneContext)

  return <DodoneInnerIgnoreButton {...dodoneContext} text={text} />
}
